/* eslint-disable max-lines */
export const SPACING_CLASSES = {
  0: {
    gap: {
      default: 'gap-0',
      xs: 'xs:gap-0',
      sm: 'sm:gap-0',
      md: 'md:gap-0',
      lg: 'lg:gap-0',
      xl: 'xl:gap-0',
    },
    padded: {
      default: 'p-0',
      xs: 'xs:p-0',
      sm: 'sm:p-0',
      md: 'md:p-0',
      lg: 'lg:p-0',
      xl: 'xl:p-0',
    },
    top: {
      default: 'mt-0',
      xs: 'xs:mt-0',
      sm: 'sm:mt-0',
      md: 'md:mt-0',
      lg: 'lg:mt-0',
      xl: 'xl:mt-0',
    },
    bottom: {
      default: 'mb-0',
      xs: 'xs:mb-0',
      sm: 'sm:mb-0',
      md: 'md:mb-0',
      lg: 'lg:mb-0',
      xl: 'xl:mb-0',
    },
    left: {
      default: 'ml-0',
      xs: 'xs:ml-0',
      sm: 'sm:ml-0',
      md: 'md:ml-0',
      lg: 'lg:ml-0',
      xl: 'xl:ml-0',
    },
    right: {
      default: 'mr-0',
      xs: 'xs:mr-0',
      sm: 'sm:mr-0',
      md: 'md:mr-0',
      lg: 'lg:mr-0',
      xl: 'xl:mr-0',
    },
  },
  1: {
    gap: {
      default: 'gap-1',
      xs: 'xs:gap-1',
      sm: 'sm:gap-1',
      md: 'md:gap-1',
      lg: 'lg:gap-1',
      xl: 'xl:gap-1',
    },
    padded: {
      default: 'p-1',
      xs: 'xs:p-1',
      sm: 'sm:p-1',
      md: 'md:p-1',
      lg: 'lg:p-1',
      xl: 'xl:p-1',
    },
    top: {
      default: 'mt-1',
      xs: 'xs:mt-1',
      sm: 'sm:mt-1',
      md: 'md:mt-1',
      lg: 'lg:mt-1',
      xl: 'xl:mt-1',
    },
    bottom: {
      default: 'mb-1',
      xs: 'xs:mb-1',
      sm: 'sm:mb-1',
      md: 'md:mb-1',
      lg: 'lg:mb-1',
      xl: 'xl:mb-1',
    },
    left: {
      default: 'ml-1',
      xs: 'xs:ml-1',
      sm: 'sm:ml-1',
      md: 'md:ml-1',
      lg: 'lg:ml-1',
      xl: 'xl:ml-1',
    },
    right: {
      default: 'mr-1',
      xs: 'xs:mr-1',
      sm: 'sm:mr-1',
      md: 'md:mr-1',
      lg: 'lg:mr-1',
      xl: 'xl:mr-1',
    },
  },
  2: {
    gap: {
      default: 'gap-2',
      xs: 'xs:gap-2',
      sm: 'sm:gap-2',
      md: 'md:gap-2',
      lg: 'lg:gap-2',
      xl: 'xl:gap-2',
    },
    padded: {
      default: 'p-2',
      xs: 'xs:p-2',
      sm: 'sm:p-2',
      md: 'md:p-2',
      lg: 'lg:p-2',
      xl: 'xl:p-2',
    },
    top: {
      default: 'mt-2',
      xs: 'xs:mt-2',
      sm: 'sm:mt-2',
      md: 'md:mt-2',
      lg: 'lg:mt-2',
      xl: 'xl:mt-2',
    },
    bottom: {
      default: 'mb-2',
      xs: 'xs:mb-2',
      sm: 'sm:mb-2',
      md: 'md:mb-2',
      lg: 'lg:mb-2',
      xl: 'xl:mb-2',
    },
    left: {
      default: 'ml-2',
      xs: 'xs:ml-2',
      sm: 'sm:ml-2',
      md: 'md:ml-2',
      lg: 'lg:ml-2',
      xl: 'xl:ml-2',
    },
    right: {
      default: 'mr-2',
      xs: 'xs:mr-2',
      sm: 'sm:mr-2',
      md: 'md:mr-2',
      lg: 'lg:mr-2',
      xl: 'xl:mr-2',
    },
  },
  3: {
    gap: {
      default: 'gap-3',
      xs: 'xs:gap-3',
      sm: 'sm:gap-3',
      md: 'md:gap-3',
      lg: 'lg:gap-3',
      xl: 'xl:gap-3',
    },
    padded: {
      default: 'p-3',
      xs: 'xs:p-3',
      sm: 'sm:p-3',
      md: 'md:p-3',
      lg: 'lg:p-3',
      xl: 'xl:p-3',
    },
    top: {
      default: 'mt-3',
      xs: 'xs:mt-3',
      sm: 'sm:mt-3',
      md: 'md:mt-3',
      lg: 'lg:mt-3',
      xl: 'xl:mt-3',
    },
    bottom: {
      default: 'mb-3',
      xs: 'xs:mb-3',
      sm: 'sm:mb-3',
      md: 'md:mb-3',
      lg: 'lg:mb-3',
      xl: 'xl:mb-3',
    },
    left: {
      default: 'ml-3',
      xs: 'xs:ml-3',
      sm: 'sm:ml-3',
      md: 'md:ml-3',
      lg: 'lg:ml-3',
      xl: 'xl:ml-3',
    },
    right: {
      default: 'mr-3',
      xs: 'xs:mr-3',
      sm: 'sm:mr-3',
      md: 'md:mr-3',
      lg: 'lg:mr-3',
      xl: 'xl:mr-3',
    },
  },
  4: {
    gap: {
      default: 'gap-4',
      xs: 'xs:gap-4',
      sm: 'sm:gap-4',
      md: 'md:gap-4',
      lg: 'lg:gap-4',
      xl: 'xl:gap-4',
    },
    padded: {
      default: 'p-4',
      xs: 'xs:p-4',
      sm: 'sm:p-4',
      md: 'md:p-4',
      lg: 'lg:p-4',
      xl: 'xl:p-4',
    },
    top: {
      default: 'mt-4',
      xs: 'xs:mt-4',
      sm: 'sm:mt-4',
      md: 'md:mt-4',
      lg: 'lg:mt-4',
      xl: 'xl:mt-4',
    },
    bottom: {
      default: 'mb-4',
      xs: 'xs:mb-4',
      sm: 'sm:mb-4',
      md: 'md:mb-4',
      lg: 'lg:mb-4',
      xl: 'xl:mb-4',
    },
    left: {
      default: 'ml-4',
      xs: 'xs:ml-4',
      sm: 'sm:ml-4',
      md: 'md:ml-4',
      lg: 'lg:ml-4',
      xl: 'xl:ml-4',
    },
    right: {
      default: 'mr-4',
      xs: 'xs:mr-4',
      sm: 'sm:mr-4',
      md: 'md:mr-4',
      lg: 'lg:mr-4',
      xl: 'xl:mr-4',
    },
  },
  5: {
    gap: {
      default: 'gap-5',
      xs: 'xs:gap-5',
      sm: 'sm:gap-5',
      md: 'md:gap-5',
      lg: 'lg:gap-5',
      xl: 'xl:gap-5',
    },
    padded: {
      default: 'p-5',
      xs: 'xs:p-5',
      sm: 'sm:p-5',
      md: 'md:p-5',
      lg: 'lg:p-5',
      xl: 'xl:p-5',
    },
    top: {
      default: 'mt-5',
      xs: 'xs:mt-5',
      sm: 'sm:mt-5',
      md: 'md:mt-5',
      lg: 'lg:mt-5',
      xl: 'xl:mt-5',
    },
    bottom: {
      default: 'mb-5',
      xs: 'xs:mb-5',
      sm: 'sm:mb-5',
      md: 'md:mb-5',
      lg: 'lg:mb-5',
      xl: 'xl:mb-5',
    },
    left: {
      default: 'ml-5',
      xs: 'xs:ml-5',
      sm: 'sm:ml-5',
      md: 'md:ml-5',
      lg: 'lg:ml-5',
      xl: 'xl:ml-5',
    },
    right: {
      default: 'mr-5',
      xs: 'xs:mr-5',
      sm: 'sm:mr-5',
      md: 'md:mr-5',
      lg: 'lg:mr-5',
      xl: 'xl:mr-5',
    },
  },
  6: {
    gap: {
      default: 'gap-6',
      xs: 'xs:gap-6',
      sm: 'sm:gap-6',
      md: 'md:gap-6',
      lg: 'lg:gap-6',
      xl: 'xl:gap-6',
    },
    padded: {
      default: 'p-6',
      xs: 'xs:p-6',
      sm: 'sm:p-6',
      md: 'md:p-6',
      lg: 'lg:p-6',
      xl: 'xl:p-6',
    },
    top: {
      default: 'mt-6',
      xs: 'xs:mt-6',
      sm: 'sm:mt-6',
      md: 'md:mt-6',
      lg: 'lg:mt-6',
      xl: 'xl:mt-6',
    },
    bottom: {
      default: 'mb-6',
      xs: 'xs:mb-6',
      sm: 'sm:mb-6',
      md: 'md:mb-6',
      lg: 'lg:mb-6',
      xl: 'xl:mb-6',
    },
    left: {
      default: 'ml-6',
      xs: 'xs:ml-6',
      sm: 'sm:ml-6',
      md: 'md:ml-6',
      lg: 'lg:ml-6',
      xl: 'xl:ml-6',
    },
    right: {
      default: 'mr-6',
      xs: 'xs:mr-6',
      sm: 'sm:mr-6',
      md: 'md:mr-6',
      lg: 'lg:mr-6',
      xl: 'xl:mr-6',
    },
  },
  8: {
    gap: {
      default: 'gap-8',
      xs: 'xs:gap-8',
      sm: 'sm:gap-8',
      md: 'md:gap-8',
      lg: 'lg:gap-8',
      xl: 'xl:gap-8',
    },
    padded: {
      default: 'p-8',
      xs: 'xs:p-8',
      sm: 'sm:p-8',
      md: 'md:p-8',
      lg: 'lg:p-8',
      xl: 'xl:p-8',
    },
    top: {
      default: 'mt-8',
      xs: 'xs:mt-8',
      sm: 'sm:mt-8',
      md: 'md:mt-8',
      lg: 'lg:mt-8',
      xl: 'xl:mt-8',
    },
    bottom: {
      default: 'mb-8',
      xs: 'xs:mb-8',
      sm: 'sm:mb-8',
      md: 'md:mb-8',
      lg: 'lg:mb-8',
      xl: 'xl:mb-8',
    },
    left: {
      default: 'ml-8',
      xs: 'xs:ml-8',
      sm: 'sm:ml-8',
      md: 'md:ml-8',
      lg: 'lg:ml-8',
      xl: 'xl:ml-8',
    },
    right: {
      default: 'mr-8',
      xs: 'xs:mr-8',
      sm: 'sm:mr-8',
      md: 'md:mr-8',
      lg: 'lg:mr-8',
      xl: 'xl:mr-8',
    },
  },
  10: {
    gap: {
      default: 'gap-10',
      xs: 'xs:gap-10',
      sm: 'sm:gap-10',
      md: 'md:gap-10',
      lg: 'lg:gap-10',
      xl: 'xl:gap-10',
    },
    padded: {
      default: 'p-10',
      xs: 'xs:p-10',
      sm: 'sm:p-10',
      md: 'md:p-10',
      lg: 'lg:p-10',
      xl: 'xl:p-10',
    },
    top: {
      default: 'mt-10',
      xs: 'xs:mt-10',
      sm: 'sm:mt-10',
      md: 'md:mt-10',
      lg: 'lg:mt-10',
      xl: 'xl:mt-10',
    },
    bottom: {
      default: 'mb-10',
      xs: 'xs:mb-10',
      sm: 'sm:mb-10',
      md: 'md:mb-10',
      lg: 'lg:mb-10',
      xl: 'xl:mb-10',
    },
    left: {
      default: 'ml-10',
      xs: 'xs:ml-10',
      sm: 'sm:ml-10',
      md: 'md:ml-10',
      lg: 'lg:ml-10',
      xl: 'xl:ml-10',
    },
    right: {
      default: 'mr-10',
      xs: 'xs:mr-10',
      sm: 'sm:mr-10',
      md: 'md:mr-10',
      lg: 'lg:mr-10',
      xl: 'xl:mr-10',
    },
  },
  12: {
    gap: {
      default: 'gap-12',
      xs: 'xs:gap-12',
      sm: 'sm:gap-12',
      md: 'md:gap-12',
      lg: 'lg:gap-12',
      xl: 'xl:gap-12',
    },
    padded: {
      default: 'p-12',
      xs: 'xs:p-12',
      sm: 'sm:p-12',
      md: 'md:p-12',
      lg: 'lg:p-12',
      xl: 'xl:p-12',
    },
    top: {
      default: 'mt-12',
      xs: 'xs:mt-12',
      sm: 'sm:mt-12',
      md: 'md:mt-12',
      lg: 'lg:mt-12',
      xl: 'xl:mt-12',
    },
    bottom: {
      default: 'mb-12',
      xs: 'xs:mb-12',
      sm: 'sm:mb-12',
      md: 'md:mb-12',
      lg: 'lg:mb-12',
      xl: 'xl:mb-12',
    },
    left: {
      default: 'ml-12',
      xs: 'xs:ml-12',
      sm: 'sm:ml-12',
      md: 'md:ml-12',
      lg: 'lg:ml-12',
      xl: 'xl:ml-12',
    },
    right: {
      default: 'mr-12',
      xs: 'xs:mr-12',
      sm: 'sm:mr-12',
      md: 'md:mr-12',
      lg: 'lg:mr-12',
      xl: 'xl:mr-12',
    },
  },
} as const

export const DEPRECATED_CLASSES = {
  xsmall: {
    gap: SPACING_CLASSES[2].gap,
    padded: SPACING_CLASSES[2].padded,
    top: SPACING_CLASSES[2].top,
    bottom: SPACING_CLASSES[2].bottom,
    left: SPACING_CLASSES[2].left,
    right: SPACING_CLASSES[2].right,
  },
  small: {
    gap: SPACING_CLASSES[4].gap,
    padded: SPACING_CLASSES[4].padded,
    top: SPACING_CLASSES[4].top,
    bottom: SPACING_CLASSES[4].bottom,
    left: SPACING_CLASSES[4].left,
    right: SPACING_CLASSES[4].right,
  },
  medium: {
    gap: SPACING_CLASSES[6].gap,
    padded: SPACING_CLASSES[6].padded,
    top: SPACING_CLASSES[6].top,
    bottom: SPACING_CLASSES[6].bottom,
    left: SPACING_CLASSES[6].left,
    right: SPACING_CLASSES[6].right,
  },
  large: {
    gap: SPACING_CLASSES[8].gap,
    padded: SPACING_CLASSES[8].padded,
    top: SPACING_CLASSES[8].top,
    bottom: SPACING_CLASSES[8].bottom,
    left: SPACING_CLASSES[8].left,
    right: SPACING_CLASSES[8].right,
  },
  xlarge: {
    gap: SPACING_CLASSES[10].gap,
    padded: SPACING_CLASSES[10].padded,
    top: SPACING_CLASSES[10].top,
    bottom: SPACING_CLASSES[10].bottom,
    left: SPACING_CLASSES[10].left,
    right: SPACING_CLASSES[10].right,
  },
} as const
